/* Claude - predictive search controller.
   Pairs sections/luna-header.liquid (chrome) with sections/luna-predictive-search.liquid
   (results), fetched through Shopify's Section Rendering API. No dependencies. */
(function () {
  'use strict';

  var RECENT_KEY = 'luna.recent';
  var RECENT_MAX = 6;

  function readRecent() {
    try { return JSON.parse(localStorage.getItem(RECENT_KEY)) || []; }
    catch (e) { return []; }
  }

  function pushRecent(term) {
    if (!term) return;
    try {
      var list = readRecent().filter(function (t) { return t.toLowerCase() !== term.toLowerCase(); });
      list.unshift(term);
      localStorage.setItem(RECENT_KEY, JSON.stringify(list.slice(0, RECENT_MAX)));
    } catch (e) { /* private mode - recent searches just won't persist */ }
  }

  function init(root) {
    if (!root || root.__luna) return;
    root.__luna = true;

    var trigger = document.querySelector('[data-luna-search-open][aria-controls="' + root.id + '"]')
               || document.querySelector('[data-luna-search-open]');
    var panel   = root.querySelector('[data-luna-sr-panel]');
    var input   = root.querySelector('[data-luna-sr-input]');
    var results = root.querySelector('[data-luna-sr-results]');
    var hint    = root.querySelector('[data-luna-sr-hint]');
    var recent  = root.querySelector('[data-luna-sr-recent]');
    var clearBt = root.querySelector('[data-luna-sr-clear]');
    var scrim   = root.querySelector('[data-luna-sr-scrim]');
    var closeBt = root.querySelector('[data-luna-sr-close]');
    if (!input || !results) return;

    var endpoint = root.dataset.endpoint || '/search/suggest';
    var types    = root.dataset.types || 'query,product,collection';
    var limit    = parseInt(root.dataset.limit, 10) || 6;
    var minChars = parseInt(root.dataset.min, 10) || 2;
    var wait     = parseInt(root.dataset.debounce, 10) || 250;

    var timer = null;
    var ctrl = null;
    var cursor = -1;

    function options() {
      return Array.prototype.slice.call(results.querySelectorAll('[role="option"]'));
    }

    function setCursor(i) {
      var opts = options();
      if (!opts.length) { cursor = -1; return; }
      opts.forEach(function (o) { o.classList.remove('is-cur'); o.setAttribute('aria-selected', 'false'); });
      if (i < 0) i = opts.length - 1;
      if (i >= opts.length) i = 0;
      cursor = i;
      var el = opts[i];
      el.classList.add('is-cur');
      el.setAttribute('aria-selected', 'true');
      input.setAttribute('aria-activedescendant', el.id || '');
      if (el.scrollIntoView) el.scrollIntoView({ block: 'nearest' });
    }

    function paintRecent() {
      if (!recent) return;
      var list = readRecent();
      recent.innerHTML = '';
      if (!list.length) { recent.hidden = true; return; }
      recent.hidden = false;
      list.forEach(function (term) {
        var b = document.createElement('button');
        b.type = 'button';
        b.textContent = term;
        b.addEventListener('click', function () {
          input.value = term;
          input.focus();
          run(term);
        });
        recent.appendChild(b);
      });
    }

    function showIdle() {
      results.innerHTML = '';
      cursor = -1;
      input.removeAttribute('aria-activedescendant');
      if (hint) hint.hidden = false;
      paintRecent();
    }

    function open() {
      if (root.classList.contains('is-open')) return;
      root.classList.add('is-open');
      if (trigger) trigger.setAttribute('aria-expanded', 'true');
      input.setAttribute('aria-expanded', 'true');
      document.documentElement.style.overflow = 'hidden';
      showIdle();
      window.setTimeout(function () { input.focus(); }, 30);
      document.addEventListener('keydown', onKeydown);
      document.addEventListener('click', onDocClick, true);
    }

    function close() {
      if (!root.classList.contains('is-open')) return;
      root.classList.remove('is-open');
      if (trigger) { trigger.setAttribute('aria-expanded', 'false'); trigger.focus(); }
      input.setAttribute('aria-expanded', 'false');
      document.documentElement.style.overflow = '';
      if (ctrl) { ctrl.abort(); ctrl = null; }
      window.clearTimeout(timer);
      document.removeEventListener('keydown', onKeydown);
      document.removeEventListener('click', onDocClick, true);
    }

    function onDocClick(e) {
      if (!root.classList.contains('is-open')) return;
      if (panel && panel.contains(e.target)) return;
      if (trigger && trigger.contains(e.target)) return;
      close();
    }

    function onKeydown(e) {
      if (e.key === 'Escape') { e.preventDefault(); close(); return; }
      if (e.key === 'ArrowDown') { e.preventDefault(); setCursor(cursor + 1); return; }
      if (e.key === 'ArrowUp')   { e.preventDefault(); setCursor(cursor - 1); return; }
      if (e.key === 'Enter') {
        var opts = options();
        if (cursor > -1 && opts[cursor]) {
          e.preventDefault();
          pushRecent(input.value.trim());
          opts[cursor].click();
        }
      }
    }

    function run(term) {
      if (ctrl) ctrl.abort();
      ctrl = ('AbortController' in window) ? new AbortController() : null;

      // limit_scope=each makes the limit per group. Without it Shopify spreads a
      // single total across all types, so "6" would yield ~2 products.
      // Never append preview_theme_id here: the endpoint 422s when that is combined
      // with resources[...]. Theme preview already works off the preview cookie.
      var url = endpoint
        + '?q=' + encodeURIComponent(term)
        + '&section_id=luna-predictive-search'
        + '&resources[type]=' + encodeURIComponent(types)
        + '&resources[limit]=' + limit
        + '&resources[limit_scope]=each';

      fetch(url, ctrl ? { signal: ctrl.signal } : undefined)
        .then(function (res) {
          if (!res.ok) throw new Error('suggest ' + res.status);
          return res.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var section = doc.querySelector('#shopify-section-luna-predictive-search');
          results.innerHTML = section ? section.innerHTML : '';
          options().forEach(function (o, i) { if (!o.id) o.id = 'luna-ps-o' + i; });
          cursor = -1;
          input.removeAttribute('aria-activedescendant');
          if (hint) hint.hidden = true;
          if (recent) recent.hidden = true;
        })
        .catch(function (err) {
          if (err && err.name === 'AbortError') return;
          // Network hiccup or a 429 throttle - leave the panel usable, let Enter
          // fall through to the full results page rather than showing a dead end.
          results.innerHTML = '';
          if (hint) hint.hidden = false;
        });
    }

    input.addEventListener('input', function () {
      var term = input.value.trim();
      if (clearBt) clearBt.hidden = !term;
      window.clearTimeout(timer);
      if (term.length < minChars) { showIdle(); return; }
      timer = window.setTimeout(function () { run(term); }, wait);
    });

    // Submitting goes to the real results page - predictive is a shortcut, not a replacement.
    var form = root.querySelector('form');
    if (form) {
      form.addEventListener('submit', function () { pushRecent(input.value.trim()); });
    }

    if (trigger) {
      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        root.classList.contains('is-open') ? close() : open();
      });
    }
    if (closeBt) closeBt.addEventListener('click', close);
    if (scrim) scrim.addEventListener('click', close);
    if (clearBt) {
      clearBt.addEventListener('click', function () {
        input.value = '';
        clearBt.hidden = true;
        input.focus();
        showIdle();
      });
    }

    root.lunaSearch = { open: open, close: close };
  }

  function boot() {
    document.querySelectorAll('[data-luna-search]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();